app.service('deliveryPointLocation', function () {

	function findPlaceByAddress(address, setPoint) {
		const options = {
			componentRestrictions: { country: "pl" },
			address: address
		};
		const geocoder = new google.maps.Geocoder();
		geocoder.geocode(options, function (results, status) {
			if (status == google.maps.GeocoderStatus.OK && results && results.length) {
				const partialMatch = results[0]["partial_match"] || false;
				const bounds = results[0].geometry.viewport;
				const location = results[0].geometry.location;
				setPoint(location, partialMatch, bounds);
			} else {
				setPoint(false);
			}
		});
	}

	return {
		findPlaceByAddress
	};
});